import { LoadingButton } from "@mui/lab";
import { Box, Button } from "@mui/material"
import { observer } from "mobx-react-lite"
import { useStore } from "../../../app/stores/store";

interface Props {
    isFilterApplied: boolean;
    clearAllFilter: () => void;
}

const HomeTableEquipmentTableButtons = ({ isFilterApplied, clearAllFilter }: Props) => {
    const { homeTableEquipmentStore, commonStore } = useStore()
    const { selectedStation } = commonStore
    const { downloadExcel, loadingDownload } = homeTableEquipmentStore
    
    const handleDownload = () => {
        if (selectedStation)  {
            downloadExcel(selectedStation.id)
        }
    }
    
    return (
        <Box display="flex" justifyContent="flex-end">
            <LoadingButton 
                loading={loadingDownload}
                onClick={handleDownload}
                variant="contained" 
                color="success"
            >
                Download Excel
            </LoadingButton>
            {isFilterApplied && (
                <Button 
                    sx={{ ml: 2 }}
                    variant="contained" 
                    color="inherit"
                    onClick={clearAllFilter}
                >
                    Clear All Filter
                </Button>
            )}
        </Box>
    )
}

export default observer(HomeTableEquipmentTableButtons)